"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HearingSectionConflicts = exports.HearingSectionConflict = exports.HearingSection = exports.HearingSectionSchema = exports.Case = exports.CaseTitleSchema = exports.MAX_CASE_TITLE_LENGTH = exports.CaseReferenceSchema = exports.MAX_CASE_REFERENCE_LENGTH = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const joda_schemas_1 = require("./joda.schemas");
exports.MAX_CASE_REFERENCE_LENGTH = 1000;
exports.CaseReferenceSchema = zod_1.default
    .string()
    .trim()
    .min(1)
    .max(exports.MAX_CASE_REFERENCE_LENGTH)
    .transform(value => value.toUpperCase());
exports.MAX_CASE_TITLE_LENGTH = 1000;
exports.CaseTitleSchema = zod_1.default
    .string()
    .trim()
    .min(1)
    .max(exports.MAX_CASE_TITLE_LENGTH)
    .transform(value => value.replaceAll('\n', ' '));
const CaseSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    caseReference: exports.CaseReferenceSchema,
    caseTitle: exports.CaseTitleSchema.nullable(),
    hearingCount: zod_1.default.number(),
    lastHeardDate: joda_schemas_1.LocalDateSchema.nullable(),
});
exports.Case = CaseSchema.refine((refine_1.is));
exports.HearingSectionSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    recordingId: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    startTime: joda_schemas_1.LocalTimeNoNanosSchema,
    endTime: joda_schemas_1.LocalTimeNoNanosSchema,
    recordedCaseTitle: exports.CaseTitleSchema.nullable(),
    caseReference: exports.CaseReferenceSchema.nullable(),
    hearingId: zod_1.default.string().uuid().nullable(),
});
exports.HearingSection = exports.HearingSectionSchema.refine((refine_1.is));
const HearingSectionConflictSchema = zod_1.default.object({
    hearingSectionId: zod_1.default.string().uuid(),
    type: zod_1.default.enum(['start-overlap', 'end-overlap', 'complete-overlap']),
});
exports.HearingSectionConflict = HearingSectionConflictSchema.refine((refine_1.is));
const HearingSectionConflictsSchema = zod_1.default.object({
    error: zod_1.default.string(),
    conflicts: zod_1.default.array(HearingSectionConflictSchema),
    conflictResolutionToken: zod_1.default.string(),
});
exports.HearingSectionConflicts = HearingSectionConflictsSchema.refine((refine_1.is));
